function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148980",
  "data-name": "Path 148980",
  d: "M16.9,22.662a1.042,1.042,0,0,1-1.09-1.067V15.957l.116-2.482-1.079,1.346-1.334,1.4a1.015,1.015,0,0,1-.742.313.969.969,0,0,1-1.009-.986,1.006,1.006,0,0,1,.29-.731l3.99-4.037a1.112,1.112,0,0,1,.858-.418,1.16,1.16,0,0,1,.882.418l3.967,4.037a1.009,1.009,0,1,1-1.45,1.4l-1.322-1.392-1.09-1.369L18,15.957v5.638A1.045,1.045,0,0,1,16.9,22.662Z",
  transform: "translate(-11.759 -10.366)",
  fill: "currentColor"
});

function SvgArrowHeadingUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.289 12.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeadingUp);
export default __webpack_public_path__ + "static/media/arrow_heading_up.99f38e52.svg";
export { ForwardRef as ReactComponent };